<template>
  <div>
    <PageAllow controller="StockOuts" action="sortingOutView" />
    <Breadcrumbs :items="items" />
    <v-sheet class="transparent-background-color">
      <v-card class="page-card">
        <v-card-title class="mx-3 text-h6">
          <audio :src="speech_url" autoplay></audio>
          <span class="text-subtitle-1">
            {{
              $t("CommonSortingOut.title", [
                stock_out && stock_out.stock_order_code
                  ? stock_out.stock_order_code
                  : "",
                stock_out && stock_out.shop ? stock_out.shop.shop_name : "",
              ])
            }}
          </span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-row class="mb-12" align="center">
            <v-col
              cols="4"
              class="font-weight-bold text-right text-align-center"
            >
              {{ $t("CommonSortingOut.bar_code_input") + $t("Global.colon") }}
            </v-col>
            <v-col cols="8">
              <v-text-field
                v-model="bar_code"
                id="barcode"
                @blur="getFocus()"
                type="text"
                single-line
                dense
                hide-details
                style="max-width: 200px; margin-right: auto"
                :placeholder="$t('CommonSortingOut.bar_code')"
                autofocus
                @keydown.enter="barCode = bar_code"
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row dense class="mx-5">
            <v-col cols="6">
              <v-card>
                <v-card-title class="mx-3">
                  {{ $t("CommonSortingOut.unsorted") }}
                </v-card-title>
                <v-divider></v-divider>
                <!-- 未分拣 -->
                <v-data-table
                  :headers="Headers"
                  hide-default-header
                  :items="stock_order_details"
                  multi-sort
                  class="elevation-0 px-6"
                  fixed-header
                  disable-pagination
                  hide-default-footer
                >
                  <template v-slot:item.sorting_num="{ item }">
                    {{ $t("CommonSortingOut.out_num") + item.sorting_num
                    }}{{ item.stock_unit }}
                    <span v-if="item.count_unit && item.count_unit_rate">
                      ({{
                        $numberFormatter.formatTwoDot(
                          item.sorting_num / item.count_unit_rate
                        )
                      }}{{ item.count_unit }})
                    </span>
                  </template>
                </v-data-table>
              </v-card>
            </v-col>
            <v-col cols="6">
              <v-card>
                <v-card-title class="mx-3">
                  {{ $t("CommonSortingOut.sorted") }}
                </v-card-title>
                <v-divider></v-divider>
                <!-- 已分拣 -->
                <v-data-table
                  :headers="sortedHeaders"
                  :items="sorted_details"
                  multi-sort
                  class="elevation-0 px-6"
                  fixed-header
                  disable-pagination
                  hide-default-footer
                  hide-default-header
                >
                  <template v-slot:item.sorting_num="{ item }">
                    {{ $t("CommonSortingOut.out_num") + item.sorting_num
                    }}{{ item.stock_unit
                    }}<span v-if="item.count_unit && item.count_unit_rate">
                      ({{
                        $numberFormatter.formatTwoDot(
                          item.sorting_num / item.count_unit_rate
                        )
                      }}{{ item.count_unit }})
                    </span>
                  </template>
                  <template v-slot:item.sorting_scan_num="{ item }">
                    {{
                      $t("CommonSortingOut.scan_num") + item.sorting_scan_num
                    }}
                  </template>
                  <template v-slot:item.sorted_num="{ item }">
                    <!-- 库存单位为称重单位时显示库存单位，否则显示基准单位 -->
                    {{ $t("CommonSortingOut.sort_num") }}
                    <a
                      @click="
                        addNumDialog = true;
                        currentItem = JSON.parse(JSON.stringify(item));
                      "
                    >
                      {{ item.sorted_num
                      }}{{
                        item.stock_unit == "kg" ||
                        item.stock_unit == "公斤" ||
                        item.stock_unit == "千克" ||
                        item.stock_unit == "g" ||
                        item.stock_unit == "克" ||
                        item.stock_unit == "斤"
                          ? item.stock_unit
                          : item.default_unit
                      }}
                    </a>
                  </template>
                </v-data-table>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <v-card class="page-opts">
        <v-card-title>
          <v-row dense>
            <v-col cols="12">
              <!-- 暂存 -->
              <v-btn
                color="success"
                block
                @click="temp()"
                :disabled="disabledActions"
              >
                <v-icon small class="pe-1">fa-save</v-icon>
                {{ $t("CommonSortingOut.temp") }}
              </v-btn>
            </v-col>
            <v-col cols="12">
              <!-- 完成 -->
              <v-btn
                color="success"
                block
                @click="confirmOut()"
                :disabled="disabledActions"
              >
                <v-icon small class="pe-1">fa-save</v-icon>
                {{ $t("CommonSortingOut.finish") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-title>
      </v-card>
    </v-sheet>
    <!-- 单据无商品提示 -->
    <DialogAlert
      v-model="nullDialog"
      :message="$t('CommonSortingOut.no_material_found')"
    />
    <!-- 重复扫码提示 -->
    <DialogAlert
      v-if="sameDialog"
      v-model="sameDialog"
      :message="$t('CommonSortingOut.barcodeRepeat')"
      useConfirm
      @confirm="confirmAdd()"
      @cancel="
        bar_code = '';
        barCode = '';
      "
    />
    <!-- 未完成提示 -->
    <!-- <DialogAlert
      v-model="sameDialog"
      :message="$t('CommonSortingOut.barcodeRepeat')"
      useConfirm
      @confirm="confirmAdd()"
    /> -->
    <!-- 分拣完成提示 -->
    <DialogAlert
      v-model="confirmOutDialog"
      :message="$t('CommonSortingOut.incomplete')"
      useConfirm
      @confirm="sortingOut()"
    />

    <!-- 修改分拣量 -->
    <v-dialog v-model="addNumDialog" width="600px">
      <v-card>
        <v-card-title class="mx-3">
          {{ $t("CommonSortingOut.sort_num_change") }}
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" @click="addNumDialog = false">
                fa-times
              </v-icon>
            </template>
            {{ $t("$vuetify.close") }}
          </v-tooltip>
        </v-card-title>
        <v-divider />
        <v-card-text class="pa-8 subtitle-1">
          <v-row>
            <v-col cols="3" class="font-weight-bold text-right">
              {{ $t("CommonSortingOut.num") }}{{ $t("Global.colon") }}
            </v-col>
            <v-col cols="9">
              <v-text-field
                v-model="currentItem.sorted_num"
                dense
                type="number"
              >
              </v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="secondary" outlined @click="addNumDialog = false">
            {{ $t("$vuetify.close") }}
          </v-btn>
          <v-btn color="primary" depressed @click="sortNumChange()">
            {{ $t("$vuetify.save") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<style scoped>
.v-list {
  display: none !important;
}
.v-menu__content {
  margin-top: 45px;
}
</style>
<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import StockOuts from "@/api/stock_outs";
import DialogAlert from "@/components/plugins/DialogAlert";

export default {
  components: {
    PageAllow,
    Breadcrumbs,
    DialogAlert,
  },
  data: () => ({
    stock_order_details: [],
    stock_order_details_reference: [],
    stock_out: {},
    sorted_details: [],
    bar_code: "",
    monitorTime: "",
    nullDialog: false,
    sameDialog: false,
    addComfirm: false,
    stock: {},
    addNumDialog: false,
    currentItem: {},
    speech_url: "",
    disabledActions: false,
    confirmOutDialog: false,
    barCode: "",
    codes: [],
  }),
  mounted() {
    this.getSortingOutViewFromAPI();
  },
  computed: {
    items() {
      return [
        {
          text: i18n.t("Nav.home"),
          disabled: false,
          href: "/home",
        },
        {
          text: this.$route.path.startsWith("/order-stock-out")
            ? i18n.t("Nav.orderManagement")
            : i18n.t("Nav.stockManagement"),
          disabled: false,
          href: this.$route.path.startsWith("/order-stock-out")
            ? "/orders"
            : "/stocks",
        },
        {
          text: this.$route.path.startsWith("/order-stock-out")
            ? i18n.t("Nav.ordersStockOrdersOut")
            : i18n.t("Nav.stockOrdersOut"),
          disabled: false,
          href: this.$route.path.startsWith("/order-stock-out")
            ? "/order-stock-out"
            : "/stock-orders-out",
        },
        {
          text: i18n.t("CommonSortingOut.sortingOut"),
          disabled: true,
          href: "",
        },
      ];
    },
    Headers() {
      return [
        {
          text: "",
          align: "start",
          sortable: false,
          class: "text-no-wrap",
          value: "material_name",
        },
        {
          text: "",
          align: "start",
          sortable: false,
          class: "text-no-wrap",
          value: "sorting_num",
        },
      ];
    },
    sortedHeaders() {
      return [
        {
          text: "",
          align: "start",
          sortable: false,
          class: "text-no-wrap",
          value: "material_name",
        },
        {
          text: "",
          align: "start",
          sortable: false,
          class: "text-no-wrap",
          value: "sorting_num",
        },
        {
          text: "",
          align: "start",
          sortable: false,
          class: "text-no-wrap",
          value: "sorting_scan_num",
        },
        // 分拣量
        {
          text: "",
          align: "start",
          sortable: false,
          class: "text-no-wrap",
          value: "sorted_num",
        },
      ];
    },
    ...mapState(["loading", "stickTableCols", "accountUser"]),
  },

  methods: {
    getSortingOutViewFromAPI() {
      StockOuts.fetchSortingOutView(this.$route.params.id).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.stock = response.data.stock;
            this.stock_order_details = response.data.stock_order_details.map(
              (detail) => {
                detail = Object.assign({}, detail, {
                  sorting_num_default: detail.sorting_num, //出库量参考值
                });
                return detail;
              }
            );

            this.stock_order_details_reference = response.data
              .stock_order_details
              ? response.data.stock_order_details.map((detail) => {
                  return detail;
                })
              : [];
            this.stock_out = response.data.stock_out;
            StockOuts.speech(this.stock_out.shop.shop_name).then(
              function (response) {
                if (response.data.status.isOK()) {
                  this.speech_url = response.data.speech_url;
                }
              }.bind(this)
            );
            var stock_order_details = localStorage.getItem(
              "stock_order_details-" +
                this.stock_out.stock_order_code +
                "-" +
                this.accountUser.id
            );
            var sorted_details = localStorage.getItem(
              "sorted_details-" +
                this.stock_out.stock_order_code +
                "-" +
                this.accountUser.id
            );
            if (stock_order_details) {
              this.stock_order_details = JSON.parse(stock_order_details);
            }
            if (sorted_details) {
              this.sorted_details = JSON.parse(sorted_details);
            }
          } else {
            // 报错时禁用暂存和完成按钮
            this.disabledActions = true;
          }
        }.bind(this)
      );
    },
    confirmAdd() {
      var material_code = this.bar_code.slice(
        this.stock.sorting_material_barcode_setting.material_code_start - 1,
        this.stock.sorting_material_barcode_setting.material_code_end
      );
      var weight_code = this.bar_code.slice(
        this.stock.sorting_material_barcode_setting.weight_code_start - 1,
        this.stock.sorting_material_barcode_setting.weight_code_end
      );
      this.sorted_details.forEach((material) => {
        if (material.material_code == material_code) {
          if (material.stock_unit == "g" || material.stock_unit == "克") {
            material.sorted_num = this.$numberFormatter.formatWithDot(
              Number(material.sorted_num) + Number(weight_code),
              3
            );
          } else if (
            material.stock_unit == "kg" ||
            material.stock_unit == "公斤" ||
            material.stock_unit == "千克"
          ) {
            material.sorted_num = this.$numberFormatter.formatWithDot(
              Number(material.sorted_num) + Number(weight_code) * 0.001,
              3
            );
          } else {
            material.sorted_num = this.$numberFormatter.formatWithDot(
              Number(material.sorted_num) + Number(weight_code) * 0.002,
              3
            );
          }
          material.sorting_scan_num += 1;
          this.bar_code = "";
          this.barCode = "";
        }
      });
      this.sameDialog = false;
    },
    // 暂存
    temp() {
      localStorage.setItem(
        "stock_order_details-" +
          this.stock_out.stock_order_code +
          "-" +
          this.accountUser.id,
        JSON.stringify(this.stock_order_details)
      );
      localStorage.setItem(
        "sorted_details-" +
          this.stock_out.stock_order_code +
          "-" +
          this.accountUser.id,
        JSON.stringify(this.sorted_details)
      );
      this.$snackbar.success(i18n.t("CommonSortingOut.tempSuccess"));
    },
    // 完成
    sortingOut() {
      this.$store.dispatch("fullscreenLoading");
      var stock_order_details = this.sorted_details.map((s) => {
        return {
          material_id: s.material_id,
          sorting_num: s.sorted_num,
          sorting_scan_num: s.sorting_scan_num,
        };
      });
      var data = {
        id: this.$route.params.id,
        stock_order_details: stock_order_details,
      };

      StockOuts.saveCommonSortingOut(data)
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              localStorage.removeItem(
                "stock_order_details-" +
                  this.stock_out.stock_order_code +
                  "-" +
                  this.accountUser.id
              );
              localStorage.removeItem(
                "sorted_details-" +
                  this.stock_out.stock_order_code +
                  "-" +
                  this.accountUser.id
              );
              if (this.$route.path.startsWith("/order-stock-out")) {
                this.$router.push("/order-stock-out");
              } else {
                this.$router.push("/stock-orders-out");
              }
            }
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        )
        .catch(
          function () {
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        );
    },
    sortNumChange() {
      this.sorted_details.splice(
        this.sorted_details.findIndex(
          (detail) => detail.material_id == this.currentItem.material_id
        ),
        1,
        this.currentItem
      );
      this.addNumDialog = false;
    },
    confirmOut() {
      if (this.stock_order_details.length) {
        this.confirmOutDialog = true;
      } else {
        this.sortingOut();
      }
    },
    getFocus() {
      clearInterval(this.monitorFocus);
      this.monitorFocus = setTimeout(
        function () {
          if (!this.addNumDialog) {
            document.getElementById("barcode").focus();
          }
        }.bind(this),
        200
      );
    },
  },
  watch: {
    barCode: {
      handler() {
        if (this.bar_code) {
          this.monitorTime = setTimeout(
            function () {
              if (
                this.stock.sorting_material_barcode_setting
                  .sorting_material_barcode_type == 1
              ) {
                var material_code = this.bar_code.slice(
                  this.stock.sorting_material_barcode_setting
                    .material_code_start - 1,
                  this.stock.sorting_material_barcode_setting.material_code_end
                );
                var weight_code = this.bar_code.slice(
                  this.stock.sorting_material_barcode_setting
                    .weight_code_start - 1,
                  this.stock.sorting_material_barcode_setting.weight_code_end
                );
                if (
                  this.stock_order_details_reference.findIndex(
                    (detail) => detail.material_code == material_code
                  ) == -1
                ) {
                  this.nullDialog = true;
                  this.bar_code = "";
                  this.barCode = "";
                } else {
                  if (
                    this.sorted_details.findIndex(
                      (detail) => detail.material_code == material_code
                    ) == -1
                  ) {
                    var num = null;
                    var material = this.stock_order_details_reference.find(
                      (material) => material.material_code == material_code
                    );
                    if (
                      material.stock_unit == "g" ||
                      material.stock_unit == "克"
                    ) {
                      num = this.$numberFormatter.formatWithDot(
                        Number(weight_code),
                        3
                      );
                    } else if (
                      material.stock_unit == "kg" ||
                      material.stock_unit == "公斤" ||
                      material.stock_unit == "千克"
                    ) {
                      num = this.$numberFormatter.formatWithDot(
                        Number(weight_code) * 0.001,
                        3
                      );
                    } else {
                      num = this.$numberFormatter.formatWithDot(
                        Number(weight_code) * 0.002,
                        3
                      );
                    }

                    this.sorted_details.unshift(
                      Object.assign({}, material, {
                        sorting_scan_num: 1,
                        sorted_num: num,
                      })
                    );
                    this.codes.push(this.barCode);
                    this.bar_code = "";
                    this.barCode = "";
                  } else {
                    if (
                      this.codes.findIndex((code) => code == this.barCode) == -1
                    ) {
                      this.codes.push(this.barCode);
                      this.sorted_details.forEach((material) => {
                        if (material.material_code == material_code) {
                          if (
                            material.stock_unit == "g" ||
                            material.stock_unit == "克"
                          ) {
                            material.sorted_num =
                              this.$numberFormatter.formatWithDot(
                                Number(material.sorted_num) +
                                  Number(weight_code),
                                3
                              );
                          } else if (
                            material.stock_unit == "kg" ||
                            material.stock_unit == "公斤" ||
                            material.stock_unit == "千克"
                          ) {
                            material.sorted_num =
                              this.$numberFormatter.formatWithDot(
                                Number(material.sorted_num) +
                                  Number(weight_code) * 0.001,
                                3
                              );
                          } else {
                            material.sorted_num =
                              this.$numberFormatter.formatWithDot(
                                Number(material.sorted_num) +
                                  Number(weight_code) * 0.002,
                                3
                              );
                          }
                          material.sorting_scan_num += 1;
                          this.bar_code = "";
                          this.barCode = "";
                        }
                      });
                    } else {
                      this.sameDialog = true;
                    }
                  }
                }
              } else {
                if (
                  this.stock_order_details_reference.findIndex(
                    (detail) => detail.material_code == this.bar_code
                  ) == -1
                ) {
                  this.nullDialog = true;
                  this.bar_code = "";
                  this.barCode = "";
                } else {
                  if (
                    this.sorted_details.findIndex(
                      (detail) => detail.material_code == this.bar_code
                    ) == -1
                  ) {
                    // 扫码一次增加一个库存单位量
                    this.sorted_details.unshift(
                      Object.assign(
                        {},
                        this.stock_order_details_reference.find(
                          (material) => material.material_code == this.bar_code
                        ),
                        { sorting_scan_num: 1, sorted_num: 1 }
                      )
                    );
                    this.bar_code = "";
                    this.barCode = "";
                  } else {
                    this.sorted_details.forEach((material) => {
                      if (material.material_code == this.bar_code) {
                        material.sorting_scan_num += 1;
                        material.sorted_num += 1;
                        this.bar_code = "";
                        this.barCode = "";
                      }
                    });
                  }
                }
              }
            }.bind(this),
            400
          );
        }
      },
    },
    sorted_details: {
      deep: true,
      handler() {
        this.sorted_details.forEach((detail) => {
          this.stock_order_details.forEach((order, index) => {
            if (detail.material_id == order.material_id) {
              if (
                order.stock_unit == "kg" ||
                order.stock_unit == "公斤" ||
                order.stock_unit == "千克" ||
                order.stock_unit == "g" ||
                order.stock_unit == "克" ||
                order.stock_unit == "斤"
              ) {
                order.sorting_num = this.$numberFormatter.formatWithDot(
                  order.sorting_num_default - detail.sorted_num,
                  3
                );
                if (order.sorting_num <= 0) {
                  this.stock_order_details.splice(index, 1);
                }
              } else {
                // 基准单位转为库存单位
                order.sorting_num = this.$numberFormatter.formatWithDot(
                  order.sorting_num_default - detail.sorted_num * detail.rate,
                  3
                );
                if (order.sorting_num <= 0) {
                  this.stock_order_details.splice(index, 1);
                }
              }
            }
          });
        });
      },
    },
    addNumDialog: {
      handler() {
        if (!this.addNumDialog) {
          this.getFocus();
        }
      },
    },
  },
  beforeDestroy() {
    clearInterval(this.monitorTime);
    clearInterval(this.monitorFocus);
  },
};
</script>
